import { render, staticRenderFns } from "./RandomWordGenerator.vue?vue&type=template&id=04340042&scoped=true&"
import script from "./RandomWordGenerator.js?vue&type=script&lang=js&"
export * from "./RandomWordGenerator.js?vue&type=script&lang=js&"
import style0 from "./RandomWordGenerator.scss?vue&type=style&index=0&id=04340042&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04340042",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RadioButton: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/RadioButton.vue').default,CustomSelect: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/CustomSelect.vue').default,InputStepper: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/InputStepper.vue').default,CircleLoader: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/CircleLoader.vue').default,WordCard: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/WordCard/WordCard.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
